import * as requests from '../coraWebComponents/utils/requests';
import urls from '../constants/Urls';

export const getMenu = async (filter) => {
    try {
        if(filter && filter.filters[0].value.length) 
            return await requests.get(`${urls.Menu}?filter=${JSON.stringify(filter)}`);
        
        return await requests.get(urls.Menu);
    }
    catch (error) {
        throw error;
    }
}
